/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGoogleGemini = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 12.02A10.649 10.649 0 0 0 12.02 22h-.04A10.649 10.649 0 0 0 2 12.02v-.04A10.649 10.649 0 0 0 11.98 2h.04A10.649 10.649 0 0 0 22 11.98z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgGoogleGemini as GoogleGemini };
